import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FcDrawerModule } from '@shared/components/fc-drawer/fc-drawer.module';
import { FcDropdownModule } from '@shared/components/fc-dropdown/fc-dropdown.module';
import { FcPaginationModule } from '@shared/components/fc-pagination/fc-pagination.module';
import { SharedModule } from '@shared/shared.module';
import { SwiperModule } from 'swiper/angular';
import { MobileProductDescriptionComponent } from './components/mobile-product-description/mobile-product-description.component';
import { MobileProductDiscussionComponent } from './components/mobile-product-discussion/mobile-product-discussion.component';
import { MobileProductFilterComponent } from './components/mobile-product-filter/mobile-product-filter.component';
import { MobileProductReviewComponent } from './components/mobile-product-review/mobile-product-review.component';
import { ProductDetailDiscussionComponent } from './components/product-detail-discussion/product-detail-discussion.component';
import { ProductDetailReviewComponent } from './components/product-detail-review/product-detail-review.component';
import { ProductFilterComponent } from './components/product-filter/product-filter.component';
import { ProductItemComponent } from './components/product-item/product-item.component';
import { MobileProductDetailComponent } from './pages/mobile/mobile-product-detail/mobile-product-detail.component';
import { ProductDetailComponent } from './pages/product-detail/product-detail.component';
import { ProductListComponent } from './pages/product-list/product-list.component';
import { ProductRoutingModule } from './product-routing.module';
import { ProductComponent } from './product.component';

@NgModule({
  declarations: [
    ProductComponent,
    ProductItemComponent,
    ProductListComponent,
    ProductDetailComponent,
    MobileProductDetailComponent,
    ProductFilterComponent,
    MobileProductFilterComponent,
    ProductDetailReviewComponent,
    ProductDetailDiscussionComponent,
    MobileProductDiscussionComponent,
    MobileProductDescriptionComponent,
    MobileProductReviewComponent,
  ],
  imports: [
    CommonModule,
    ProductRoutingModule,
    SharedModule,
    FcDropdownModule,
    FcPaginationModule,
    FcDrawerModule,
    SwiperModule,
  ],
  exports: [ProductItemComponent],
})
export class ProductModule {}
